<script>
export default {
  methods: {
    onButtonFavoriteClick(documentId, isFavorite) {
      this.$emit('favorite-click', documentId, isFavorite);
    },

    onButtonWatchedClick(documentId, isWatched) {
      this.$emit('watched-click', documentId, isWatched);
    }
  }
};
</script>
